module.exports = __webpack_public_path__ + "static/assets/593eb44eed7f681ed91dd7d285fa2445.png";